import { useMutation, useQuery } from "@apollo/client";
import { GridInputs } from "../../../../../../../components/Functional";
import { useFormik } from "formik";
import { FETCH_BANK_ACCOUNTS_V2 as fetchBankAccountsV2 } from "../../../../../../../graphql/query/BankAccount";
import { FETCH_CURRENCIES } from "../../../../../../../graphql/query/Currency";
import { UPDATE_BANK_ACCOUNT } from "../../../../../../../graphql/mutation/BankAccount";
import { Button } from "../../../../../../../components/ui";
import { CreateEditFormInputs } from "./CreateEditFormInputs";
import { buildUpdateBankAccountValidationSchema } from "./bankAccountValidation";
import useUser from "../../../../../../../hooks/useUser";

const UpdateBankAccountBody = props => {
  const { closeModal, companyId, values } = props || {};

  const [updateBankAccount, { loading }] = useMutation(UPDATE_BANK_ACCOUNT, {
    refetchQueries: [fetchBankAccountsV2({ currency: {} })],
  });

  const { data: { currencies = [] } = {} } = useQuery(FETCH_CURRENCIES);
  const { hasPermission } = useUser();
  const disabled = !hasPermission("UPDATE_BANK_ACCOUNT");
  const disabledTerms = !hasPermission("UPDATE_BANK_ACCOUNT_TERMS");

  const formik = useFormik({
    initialValues: values,
    enableReinitialize: true,
    validationSchema: buildUpdateBankAccountValidationSchema({
      validateBankDetails: !disabled,
    }),
    onSubmit: async values => {
      const omitKeys = (obj, arr) =>
        Object.fromEntries(
          Object.entries(obj).filter(([k]) => !arr.includes(k)),
        );

      const filteredValues = omitKeys(values, [
        "__typename",
        "isnewData",
        "rawFields",
        "currency",
        "canDelete",
      ]);

      updateBankAccount({
        variables: {
          input: {
            companyId: companyId,
            ...filteredValues,
          },
        },
      }).then(resp => {
        const {
          data: { updateBankAccount: { success } = {} },
        } = resp || {};
        if (success) {
          formik.resetForm();
          closeModal();
        }
      });
    },
  });

  const inputProps = {
    formik,
    ...CreateEditFormInputs({ disabled, disabledTerms, currencies }),
  };

  const hasErrors = Object.keys(formik?.errors || {}).length > 0;

  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex flex-col gap-4 sm:flex-row">
        <div className="flex flex-1 flex-col text-2xl font-bold">
          <div>Edit bank account</div>
        </div>
        <div className="flex gap-4">
          <Button
            action="default"
            label="Cancel"
            onClick={() => {
              closeModal();
              formik.resetForm();
            }}
          />
          <Button
            label={"Update"}
            loading={loading}
            disabled={loading || hasErrors}
            onClick={formik.submitForm}
          />
        </div>
      </div>
      <div className="grid">
        <GridInputs {...inputProps} />
      </div>
    </div>
  );
};

export default UpdateBankAccountBody;
